import { useState, useRef, useEffect } from "react";
import Button from "../Button/Button";
import { FiCalendar } from "react-icons/fi";
import "./YearSelect.scss";

const YearSelect = ({ options, value, onChange, placeholder = "Año" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const onClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", onClickOutside);
        return () => document.removeEventListener("mousedown", onClickOutside);
    }, []);

    const selectedOption =
        options.find((opt) => opt.value === value) || null;

    return (
        <div className="year-select" ref={ref}>
            <Button
                variant="filled"
                startIcon={<FiCalendar />}
                onClick={() => setIsOpen((prev) => !prev)}
                className={
                    isOpen ? "year-select__button year-select__button--open" : "year-select__button"
                }
            >
                {selectedOption ? selectedOption.label : placeholder}
                <span className="year-select__chevron">▾</span>
            </Button>

            {isOpen && (
                <ul className="year-select__dropdown">
                    {options.map((opt) => (
                        <li
                            key={opt.value}
                            className={
                                opt.value === value
                                    ? "year-select__option year-select__option--selected"
                                    : "year-select__option"
                            }
                            onClick={() => {
                                onChange(opt.value);
                                setIsOpen(false);
                            }}
                        >
                            {opt.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default YearSelect;
